import { useEffect } from "react";

export function initializeOverheadFilters(translate) {
  let initialFilters = [
    {
      id: "nogaCode",
      label: translate("benchmarking.evaluations.overheads.filters.noga"),
      items: [],
    },
    {
      id: "surveyYears",
      label: translate("benchmarking.evaluations.overheads.filters.year"),
      items: [],
    },
    {
      id: "officeSize",
      label: translate("benchmarking.evaluations.overheads.filters.officeSize"),
      items: [],
      ignoreSort: true,
    },
    {
      id: "greaterRegion",
      label: translate("benchmarking.evaluations.overheads.filters.canton"),
      items: [],
    },
    {
      id: "accounts",
      label: translate("benchmarking.evaluations.overheads.filters.overheads"),
      items: [],
    },
    {
      id: "reference",
      type: "dropDown",
      label: translate("benchmarking.evaluations.overheads.filters.referenceValue"),
      value: {
        id: 1,
        label: translate("benchmarking.evaluations.overheads.filters.referenceValue.turnover"),
        name: translate("benchmarking.evaluations.overheads.filters.referenceValue.turnover"),
      },
      items: [
        {
          id: 1,
          label: translate("benchmarking.evaluations.overheads.filters.referenceValue.turnover"),
          name: translate("benchmarking.evaluations.overheads.filters.referenceValue.turnover"),
        },
        {
          id: 2,
          label: translate("benchmarking.evaluations.overheads.filters.referenceValue.grossSalary"),
          name: translate("benchmarking.evaluations.overheads.filters.referenceValue.grossSalary"),
        },
      ],
    },
  ];
  let initialFiltersState = { filters: initialFilters, newest: true, isInitialLoad: true, allAvailabeFilters: {} };
  return initialFiltersState;
}

export function useStateReintialaize(setter, initializer, translate) {
  useEffect(() => {
    setter(initializer(translate));
  }, [translate]);
}
